import {
  CAMPOS_CONFIGURAVEIS_DO_CADASTRO,
  CAMPOS_DO_AUTOCADASTRO,
  ROTULO_DO_CAMPO_CONFIGURAVEL,
  type ConfiguracaoDePacientes,
  type ExigenciaDoCampo,
} from "@bookdental/schemas";
import { cn } from "@/lib/cn";

const OPCOES: { valor: ExigenciaDoCampo; rotulo: string }[] = [
  { valor: "opcional", rotulo: "Opcional" },
  { valor: "obrigatorio", rotulo: "Obrigatório" },
  { valor: "oculto", rotulo: "Oculto" },
];

const DETALHE: Partial<Record<(typeof CAMPOS_CONFIGURAVEIS_DO_CADASTRO)[number], string>> = {
  contatoDeEmergencia: "Nome e telefone",
  endereco: "CEP, rua, número, bairro, cidade e UF",
  convenio: "Nome do convênio (a carteirinha fica opcional)",
  motherName: "Hoje aparece só na ficha",
};

/** Cada campo do cadastro: opcional (como hoje), obrigatório ou oculto. Nome é sempre obrigatório. */
export function SecaoCadastro({ valor, onChange }: { valor: ConfiguracaoDePacientes; onChange: (v: ConfiguracaoDePacientes) => void }) {
  const mudar = (campo: (typeof CAMPOS_CONFIGURAVEIS_DO_CADASTRO)[number], exigencia: ExigenciaDoCampo) =>
    onChange({ ...valor, cadastro: { campos: { ...valor.cadastro.campos, [campo]: exigencia } } });

  return (
    <div className="space-y-4">
      <p className="text-[12.5px] leading-relaxed text-zinc-500 dark:text-muted-foreground">
        Vale para o Novo paciente, a aba Dados da ficha e o link de autocadastro. Obrigatório sobe para o começo do cadastro;
        oculto some das três telas (o que já estava preenchido continua guardado). O encaixe rápido pela agenda e a
        importação não são barrados: o paciente aparece com "Cadastro incompleto" até alguém completar.
      </p>
      <ul className="divide-y divide-zinc-100 rounded-lg border border-zinc-200 dark:divide-border/50 dark:border-border">
        <li className="flex items-center justify-between gap-3 px-4 py-2.5">
          <span className="text-sm font-medium text-zinc-900 dark:text-foreground">Nome</span>
          <span className="text-xs text-zinc-500 dark:text-muted-foreground">Sempre obrigatório</span>
        </li>
        {CAMPOS_CONFIGURAVEIS_DO_CADASTRO.map((campo) => (
          <li key={campo} className="flex flex-col gap-2 px-4 py-2.5 sm:flex-row sm:items-center sm:justify-between">
            <span className="min-w-0">
              <span className="block text-sm font-medium text-zinc-900 dark:text-foreground">{ROTULO_DO_CAMPO_CONFIGURAVEL[campo]}</span>
              <span className="block text-[11.5px] text-zinc-500 dark:text-muted-foreground">
                {[DETALHE[campo], !CAMPOS_DO_AUTOCADASTRO.includes(campo) && "Não entra no link de autocadastro"].filter(Boolean).join(" · ")}
              </span>
            </span>
            <span role="radiogroup" aria-label={ROTULO_DO_CAMPO_CONFIGURAVEL[campo]} className="inline-flex shrink-0 rounded-md border border-zinc-200 p-0.5 dark:border-border">
              {OPCOES.map((o) => {
                const ativo = valor.cadastro.campos[campo] === o.valor;
                return (
                  <button
                    key={o.valor}
                    type="button"
                    role="radio"
                    aria-checked={ativo}
                    onClick={() => mudar(campo, o.valor)}
                    className={cn(
                      "h-7 rounded px-2.5 text-xs font-semibold transition-colors",
                      ativo
                        ? o.valor === "oculto"
                          ? "bg-zinc-700 text-white dark:bg-zinc-500"
                          : "bg-brand-600 text-white"
                        : "text-zinc-600 hover:bg-zinc-50 dark:text-muted-foreground dark:hover:bg-muted",
                    )}
                  >
                    {o.rotulo}
                  </button>
                );
              })}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
